export const REST_API_URL = "https://testing.halper.ai/api"; //prod
// export const REST_API_URL = "https://dev.halper.ai/api"; //dev
// export const REST_API_URL = "https://gevgor.ngrok.pro/api"; //ngrok

// Sign in with Apple (web). APPLE_SERVICE_ID is the Apple "Services ID"
// (the web client_id) created in the Apple Developer console — NOT the iOS
// bundle id. Update this to the real Services ID once it is created.
// APPLE_WEB_REDIRECT_URI must exactly match a Return URL registered on that
// Services ID (HTTPS, same origin as the site).
export const APPLE_SERVICE_ID = "com.halper.ai.web";
export const APPLE_WEB_REDIRECT_URI = "https://app.halper.ai/apple-login";